<div class="message-administration">

  <sc-master-detail [selection]="[selected]" [data]="messages" (selectionChanged)="onSelectionChanged($event);" [newStyle]="true"
    (addEntry)="onAddEntry($event);" (deleteEntry)="onDeleteEntry($event);">

    <sc-scroll-pane>
      <div class="form">
        <div class="message-details">

          @if (workingCopyDetails) {
            <div class="form-box grid no-field-space" [formGroup]="detailsFormGroup">
              <sc-padding>
                <sc-flex vertical stretchContent>
                  <sc-string-field labelDictionaryKey="tmc-yard.entity.transport-message.name" formControlName="name" [required]="true"></sc-string-field>
                  <sc-content-spacer vertical></sc-content-spacer>
                  <sc-dictionary-field style="grid-column: 1; grid-row: 2;" [model]="workingCopyDetails.messageLong"
                    [defaultLabel]="'message long'"
                    [labelDictionaryKey]="'tmc-yard.entity.transport-message.message-long'" [required]="true"
                    [maxlength]="4000" (dictionaryChanged)="onDictionaryChanged()">
                  </sc-dictionary-field>
                  <sc-content-spacer vertical></sc-content-spacer>
                  <sc-dictionary-field style="grid-column: 1; grid-row: 3;" [model]="workingCopyDetails.messageShort"
                    [defaultLabel]="'message short'"
                    [labelDictionaryKey]="'tmc-yard.entity.transport-message.message-short'" [required]="true"
                    [maxlength]="4000" (dictionaryChanged)="onDictionaryChanged()">
                  </sc-dictionary-field>
                </sc-flex>
              </sc-padding>
            </div>
          }

        </div>
      </div>
    </sc-scroll-pane>

    <ng-template masterDetailToolbar>
      @if (sendEnabled) {
        <sc-button dictionaryKey="tmc-yard.ui.admin.message-administration.message-details.action.send-message" iconClass="fa-envelope" (click)="sendMessage()"
        [disabled]="isLoading"></sc-button>
      }
      <sc-content-spacer></sc-content-spacer>
      <sc-cancel-button type="button" class="config-changed-button" (click)="cancel()"
      [disabled]="!cancelEnabled"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-save-button primary type="button" class="config-changed-button" (click)="save()"
      [disabled]="!saveEnabled"></sc-save-button>
    </ng-template>

  </sc-master-detail>
</div>
